import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import ChatView from '@/views/ChatView.vue'
import ChatsView from '@/views/ChatsView.vue'
import ResumeView from '@/views/ResumeView'
import JobsView from '@/views/JobsView'
import CompanyView from '@/views/CompanyView'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path:'/chat',
    name: 'chat',
    component: ChatView
  },
  {
    path: '/chats',
    name: 'chats',
    component: ChatsView
  },
  {
    path:'/resume',
    name: 'resume',
    component: ResumeView,
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: JobsView,
  },
  {
    path: '/company',
    name: 'company',
    component: CompanyView,
  }
]

const router = new VueRouter({
  routes
})

export default router
